// @flow
import React from 'react';
import classNames from 'classnames';
import { DateUtil } from 'utils/DateUtil';
import { EventVenueCard } from 'components/molecules/eventVenueCard';
import type { Venue } from 'types/event';
import { CountryTimeUtil } from 'utils/CountryTimeUtil';
import { CURRENT_COUNTRY_CODE } from 'config/env';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Array<Venue>,
  className?: string,
  type?: string,
};

const MAX_VENUES = 3;
const MAX_EVENT_DATES = 3;

export const EventVenuesList = (props: Props) => {
  const { data, className, type } = props;
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';
  if (!data || data.length === 0) {
    return null;
  }

  if (data.length === 1) {
    return <EventVenueCard venue={data[0]} className={className} type={type} />;
  }

  const containerClass = classNames('venue-items-container', className);

  return (
    <div className={containerClass}>
      {data.slice(0, MAX_VENUES).map((venue: Venue) => {
        const eventDates = venue.eventDates;
        const validEventDates = CountryTimeUtil.filterValidEvents(eventDates, countryCode, false);
        return (
          <div className={'venue-item'} key={venue.id}>
            <div className={'location'}>
              <h4>{venue.restaurant.name}</h4>
              <span>{venue.location}</span>
            </div>
            <div className={'event-dates'}>
              {validEventDates?.slice(0, MAX_EVENT_DATES).map(eventDate => {
                return (
                  <h4 key={eventDate.date}>
                    {DateUtil.getDisplayDateFromISOString(eventDate.date)}
                    <small>&nbsp;at&nbsp;</small>
                    {eventDate.startTime}
                  </h4>
                );
              })}
              {validEventDates.length > MAX_EVENT_DATES && (
                <span>
                  and {validEventDates.length - MAX_EVENT_DATES} more upcoming
                  concerts
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
